export const privateRouteTransferTypes = [0, 6, 7]